import React from 'react'

const Info = () => {
  return (

    <div className="about__info grid">
        <div className="about__box">
            <i class='bx bx-code-alt'></i>
            <h3 className="about__title">Data & ML Engineer</h3>
            <span className="about__subtitle">Coffee in, models out</span>
        </div>

        <div className="about__box">
            <i class='bx bx-bot'></i>
            <h3 className="about__title">AI Enthusiast</h3>
            <span className="about__subtitle">Will automate anything, including this bio</span>
        </div>

        <div className="about__box">
            <i class='bx bx-microphone'></i>
            <h3 className="about__title">Church Singer</h3>
            <span className="about__subtitle">Hits A4 only... allegedly</span>
        </div>

        <div className="about__box">
            <i class='bx bx-water'></i>
            <h3 className="about__title">Shark Chaser</h3>
            <span className="about__subtitle">300 dives, 0 eaten</span>
        </div>

        <div className="about__box">
            <i class='bx bx-globe'></i>
            <h3 className="about__title">Culture Explorer</h3>
            <span className="about__subtitle">Fluent in "Hello" across 10 languages</span>
        </div>

        <div className="about__box">
            <i class='bx bx-dish'></i>
            <h3 className="about__title">Passionate Foodie</h3>
            <span className="about__subtitle">Eats like a critic, cooks like a hazard</span>
        </div>

    </div>

  )
}

export default Info
